import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icon/action/edit.svg'


const _withScopeId = n => (_pushScopeId("data-v-22ce2a07"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = { class: "flex flex-col md:flex-row justify-between items-center mb-6 gap-4" }
const _hoisted_3 = { class: "flex items-center gap-3 w-full md:w-auto flex-wrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold" }, "Filter:", -1))
const _hoisted_5 = { class: "relative w-full md:w-80 input-icon-right" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-wrap gap-2 mb-4"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "text-blue-500" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times text-xs" }, null, -1))
const _hoisted_10 = { class: "inline-block px-3 py-1 rounded-lg border border-gray-200 text-xs font-semibold text-gray-700 background-grey-lighten-5" }
const _hoisted_11 = { class: "clm-act-cntn" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mr-2 w-4 flex-shrink-0",
  alt: "edit"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-grey-5 font-semibold text-sm whitespace-nowrap" }, "Edit Komisi", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]

import { ref, reactive, computed, onMounted, getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import Card from 'primevue/card'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ProgressSpinner from 'primevue/progressspinner'
import InputText from 'primevue/inputtext'
import HeaderCustom from '@/views/components/header/HeaderHjpTable.vue'
import Paginator from '@/views/components/paginator/Paginator.vue'
import EmptyState from '@/views/components/list/EmptyState.vue'
import FilterDropdown from '@/views/components/filter/FilterDropdown.vue'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import { ISalesAgentCommission } from '@/utils/interfaces/iSalesAgentCommission'
import '@/views/components/table/hjp-data-table.scss'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const app = getCurrentInstance()
const { $toast } = (app?.appContext.config.globalProperties || {}) as any
const router = useRouter()

const isLoading = ref(false)
const dataSource = ref<ISalesAgentCommission[]>([])
const searchCharacter = ref('')

// Filter States
const appliedStationIds = ref<string[]>([])
const appliedClassIds = ref<string[]>([])

// Dropdown Options & Pagination (Stations)
const stationOptions = ref<Array<{ value: string; label: string }>>([])
const stationPagination = reactive({
  pageNumber: 1,
  pageSize: 10,
  hasNextPage: true,
  isLoading: false
})

// Dropdown Options & Pagination (Classes)
const classOptions = ref<Array<{ value: string; label: string }>>([])
const classPagination = reactive({
  pageNumber: 1,
  pageSize: 10,
  hasNextPage: true,
  isLoading: false
})

const filters = reactive({
  pageSize: 10,
  pageNumber: 1,
  totalRecords: 0
})

const formatCommissionType = (type: string): string => {
  if (!type) return '-'
  if (type === 'OneTime') return 'Mandoran Pertama'
  if (type === 'Tiered') return 'Komisi per Penumpang'
  return type
}

// Fetch Stations with pagination scrolling
const fetchStations = async (reset = false) => {
  if (stationPagination.isLoading) return
  if (reset) {
    stationPagination.pageNumber = 1
    stationPagination.hasNextPage = true
    stationOptions.value = []
  }
  if (!stationPagination.hasNextPage) return

  stationPagination.isLoading = true
  try {
    const params = returnUrlPrams({
      pageSize: stationPagination.pageSize,
      pageNumber: stationPagination.pageNumber
    })
    const res = await apiUseCase.get('/management/v2/Stations', params)
    if (!res.error && res.result) {
      const newItems = res.result.map((item: any) => ({
        value: item.Id,
        label: item.Name
      }))
      stationOptions.value = reset ? newItems : [...stationOptions.value, ...newItems]
      const totalLoaded = stationOptions.value.length
      stationPagination.hasNextPage = totalLoaded < (res.count || 0)
      stationPagination.pageNumber += 1
    } else {
      stationPagination.hasNextPage = false
    }
  } catch (err) {
    stationPagination.hasNextPage = false
  } finally {
    stationPagination.isLoading = false
  }
}

// Fetch Classes with pagination scrolling
const fetchClasses = async (reset = false) => {
  if (classPagination.isLoading) return
  if (reset) {
    classPagination.pageNumber = 1
    classPagination.hasNextPage = true
    classOptions.value = []
  }
  if (!classPagination.hasNextPage) return

  classPagination.isLoading = true
  try {
    const params = returnUrlPrams({
      custom: [['isActive', '=', 'true']],
      pageSize: classPagination.pageSize,
      pageNumber: classPagination.pageNumber
    })
    const res = await apiUseCase.get('/management/v2/Classes', params)
    if (!res.error && res.result) {
      const newItems = res.result.map((item: any) => ({
        value: item.Id,
        label: item.Name
      }))
      classOptions.value = reset ? newItems : [...classOptions.value, ...newItems]
      const totalLoaded = classOptions.value.length
      classPagination.hasNextPage = totalLoaded < (res.count || 0)
      classPagination.pageNumber += 1
    } else {
      classPagination.hasNextPage = false
    }
  } catch (err) {
    classPagination.hasNextPage = false
  } finally {
    classPagination.isLoading = false
  }
}

const onOpenStation = () => {
  if (stationOptions.value.length === 0) {
    fetchStations(true)
  }
}

const onOpenClass = () => {
  if (classOptions.value.length === 0) {
    fetchClasses(true)
  }
}

// Active Filter Pills
const activeFilters = computed(() => {
  const pills: Array<{ id: string; category: 'station' | 'class'; value: string; label: string }> = []
  appliedStationIds.value.forEach((id) => {
    const opt = stationOptions.value.find((s) => s.value === id)
    pills.push({
      id: `station_${id}`,
      category: 'station',
      value: id,
      label: opt ? opt.label : id
    })
  })
  appliedClassIds.value.forEach((id) => {
    const opt = classOptions.value.find((c) => c.value === id)
    pills.push({
      id: `class_${id}`,
      category: 'class',
      value: id,
      label: opt ? opt.label : id
    })
  })
  return pills
})

const getAllData = async () => {
  isLoading.value = true
  const custom: string[][] = []

  // Parameter 'name' untuk cari berdasarkan nama komisi
  if (searchCharacter.value && searchCharacter.value.trim()) {
    custom.push(['name', '=', searchCharacter.value.trim()])
  }

  if (appliedStationIds.value && appliedStationIds.value.length > 0) {
    custom.push(['stationIds', '=', appliedStationIds.value.join(',')])
  }

  if (appliedClassIds.value && appliedClassIds.value.length > 0) {
    custom.push(['classIds', '=', appliedClassIds.value.join(',')])
  }

  const params = returnUrlPrams({
    custom,
    pageSize: filters.pageSize,
    pageNumber: filters.pageNumber
  })

  try {
    const res = await apiUseCase.get('/management/v2/SalesAgentCommissions', params)
    if (!res.error) {
      dataSource.value = res.result || []
      filters.totalRecords = res.count || 0
      if (res.pagesize) filters.pageSize = res.pagesize
      if (res.pagenumber) filters.pageNumber = res.pagenumber
    } else {
      dataSource.value = []
      filters.totalRecords = 0
    }
  } catch (err) {
    dataSource.value = []
    filters.totalRecords = 0
  } finally {
    isLoading.value = false
  }
}

const removeFilter = (pill: { category: 'station' | 'class'; value: string }) => {
  if (pill.category === 'station') {
    appliedStationIds.value = appliedStationIds.value.filter((id) => id !== pill.value)
  } else if (pill.category === 'class') {
    appliedClassIds.value = appliedClassIds.value.filter((id) => id !== pill.value)
  }
  filters.pageNumber = 1
  getAllData()
}

const onSearch = () => {
  filters.pageNumber = 1
  getAllData()
}

const onFilterApply = () => {
  filters.pageNumber = 1
  getAllData()
}

const onChangePage = (event: any) => {
  filters.pageNumber = event.page + 1
  if (event.rows) {
    filters.pageSize = event.rows
  }
  getAllData()
}

const onClickBtnAdd = () => {
  router.push({ name: 'master-mandoran-commission-form' })
}

const onClickEdit = (item: ISalesAgentCommission) => {
  router.push({
    name: 'master-mandoran-commission-form',
    params: { id: encryptDecriptMethods.encrypt({ Id: item.Id }) }
  })
}

onMounted(() => {
  getAllData()
  fetchStations(true)
  fetchClasses(true)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-table" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(HeaderCustom, {
            titleHeader: "Komisi Mandoran",
            titleButton: "Tambah Komisi",
            showSearch: false,
            showAddBtn: true,
            onRedirectAdd: onClickBtnAdd
          })
        ])
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(FilterDropdown, {
              label: "Terminal Asal",
              title: "Filter Terminal Asal",
              options: stationOptions.value,
              loading: stationPagination.isLoading,
              modelValue: appliedStationIds.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((appliedStationIds).value = $event)),
              onOpen: onOpenStation,
              onScrollEnd: _cache[1] || (_cache[1] = ($event: any) => (fetchStations(false))),
              onApply: onFilterApply,
              onReset: onFilterApply
            }, null, 8, ["options", "loading", "modelValue"]),
            _createVNode(FilterDropdown, {
              label: "Kelas",
              title: "Filter Kelas",
              options: classOptions.value,
              loading: classPagination.isLoading,
              modelValue: appliedClassIds.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((appliedClassIds).value = $event)),
              onOpen: onOpenClass,
              onScrollEnd: _cache[3] || (_cache[3] = ($event: any) => (fetchClasses(false))),
              onApply: onFilterApply,
              onReset: onFilterApply
            }, null, 8, ["options", "loading", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(InputText), {
              modelValue: searchCharacter.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchCharacter).value = $event)),
              placeholder: "Cari Nama Komisi",
              class: "w-full input-default",
              onKeyup: _withKeys(onSearch, ["enter"])
            }, null, 8, ["modelValue", "onKeyup"]),
            _createElementVNode("i", {
              class: "pi pi-search text-neutral-400 cursor-pointer",
              onClick: onSearch
            })
          ])
        ]),
        (_unref(activeFilters).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeFilters), (pill) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: pill.id,
                  class: "border border-blue-500 bg-blue-50 hover:bg-blue-100 rounded-full px-4 py-2 text-sm flex items-center gap-2 font-medium cursor-pointer transition-colors duration-150 text-blue-500",
                  onClick: ($event: any) => (removeFilter(pill))
                }, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(pill.label), 1),
                  _hoisted_9
                ], 8, _hoisted_7))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode(_unref(DataTable), {
          id: "hjp-data-table",
          value: dataSource.value,
          paginator: false,
          loading: isLoading.value,
          class: "table-og hjp-data-table",
          responsiveLayout: "scroll"
        }, {
          empty: _withCtx(() => [
            _createVNode(EmptyState, { textNoData: "Data belum ada, silahkan tambah untuk mengisi data" })
          ]),
          loading: _withCtx(() => [
            _createVNode(_unref(ProgressSpinner), { style: {"width":"70px","height":"70px"} })
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(Column), {
              header: "Nama Komisi",
              field: "Name"
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.Name ?? '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              header: "Terminal Asal",
              field: "StationName"
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.StationName ?? '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              header: "Kelas",
              field: "ClassName"
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.ClassName ?? '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              header: "Tipe Komisi",
              field: "CommissionType"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", _hoisted_10, _toDisplayString(formatCommissionType(slotProps.data.CommissionType)), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              class: "colom-action mx-auto",
              header: "Aksi",
              headerStyle: "width: 180px; min-width: 180px; text-align: center;",
              bodyStyle: "width: 180px; min-width: 180px; text-align: center;"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: "px-4 py-2 flex items-center cursor-pointer rounded-lg background-grey-lighten-5 hover:opacity-80 transition whitespace-nowrap",
                    onClick: ($event: any) => (onClickEdit(slotProps.data))
                  }, _hoisted_15, 8, _hoisted_12)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "loading"])
      ]),
      footer: _withCtx(() => [
        (filters.totalRecords > 0)
          ? (_openBlock(), _createBlock(Paginator, {
              key: 0,
              rows: filters.pageSize,
              totalRecords: filters.totalRecords,
              onOnPage: onChangePage
            }, null, 8, ["rows", "totalRecords"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})